/**
 * @generated SignedSource<<325e4c8ef30b620d5cc32ca26ad9e4e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraPlanStatus = "ACTIVE" | "ARCHIVED" | "TRASHED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type PlanMenuItem$data = {
  readonly favouriteValue: {
    readonly isFavourite: boolean | null | undefined;
  } | null | undefined;
  readonly isReadOnly: boolean | null | undefined;
  readonly planId: AGG$Long;
  readonly planStatus: JiraPlanStatus | null | undefined;
  readonly scenario: {
    readonly scenarioId: AGG$Long;
  };
  readonly title: string | null | undefined;
  readonly " $fragmentType": "PlanMenuItem";
};
export type PlanMenuItem$key = {
  readonly " $data"?: PlanMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PlanMenuItem",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "planId"
      },
      "action": "THROW",
      "path": "planId"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "isReadOnly"
    },
    {
      "kind": "ScalarField",
      "name": "planStatus"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourite"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraScenario",
        "kind": "LinkedField",
        "name": "scenario",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "scenarioId"
            },
            "action": "THROW",
            "path": "scenario.scenarioId"
          }
        ]
      },
      "action": "THROW",
      "path": "scenario"
    }
  ],
  "type": "JiraPlan"
};

(node as any).hash = "c5fceaa084a3ebf469a6f1af8d0834b9";

export default node;
